import React, {useContext} from 'react';
import {AppCtx} from "../../../AppCtx";
import './TopFloatMenuComponent.css';

const menuWrapperStyle = {
  position: 'fixed',
  zIndex: 9, // Lower than the menu items but still high
  top: 0,
  left: 0,
  width: '100%',
  height: '38px',
  boxSizing: 'border-box',
  background: 'linear-gradient(to bottom, var(--float-menu-bg-color) 26px, var(--border-color) 26px)',
  display: 'flex',
  justifyContent: 'center',
  pointerEvents: 'none' // Let clicks pass through to elements below
};

const menuStyle = {
  position: 'fixed', 
  zIndex: 10, 
  top: 0, 
  height: '36px',
  fontSize: '24px',
  padding: 0,
  borderRadius: '10px', 
  gap: '0px',
  width: 'calc(100% - 72px)',
  left: '50%', 
  transform: 'translateX(calc(-50% + 0px))',
  backgroundColor: 'transparent', // Changed to transparent since wrapper handles background
  color: 'var(--float-menu-font-color)',
  display: 'flex', 
  alignItems: 'center', 
  justifyContent: 'flex-start',
  pointerEvents: 'auto' // Ensure menu items are clickable
};

export default ({children}) => {
  const {isTopMenuVisible} = useContext(AppCtx);
  
  return (
    <>
      {/* Full-width border wrapper */}
      <div
        className="top-menu-frame"
        style={{
          ...menuWrapperStyle,
          display: isTopMenuVisible ? 'flex' : 'none'
        }}
      />
      {/* Actual menu items */}
      <div
        className="top-float-menu"
        style={{
          ...menuStyle, 
          display: isTopMenuVisible ? 'flex' : 'none'
        }}
      >
        {children}
      </div>
    </>
  );
};
